/**
 * Advanced: "Show to N % of new installs" (spec 2026-10-23 §5). The rest is a
 * hold-out group, so the effect of the video can be measured. Folded away by
 * default: most changes never touch it.
 */
import { parseAudience } from '../lib/intro-state';

interface Props {
  value: string;
  disabled: boolean;
  onChange: (value: string) => void;
}

export function AudienceField({ value, disabled, onChange }: Props) {
  const pct = parseAudience(value);
  const invalid = pct === null;
  return (
    <details className="rounded-lg border bg-card p-5">
      <summary className="cursor-pointer text-base font-semibold">
        Advanced
        {pct !== null && pct !== 100 && (
          <span className="ml-2 text-sm font-normal text-muted-foreground">— the intro shows to {pct} % of new installs</span>
        )}
      </summary>
      <div className="mt-4 space-y-2">
        <label htmlFor="intro-audience" className="block text-sm font-medium">
          Show the intro to this percent of new installs
        </label>
        <div className="flex items-center gap-2">
          <input
            id="intro-audience"
            type="number"
            inputMode="numeric"
            min={0}
            max={100}
            step={1}
            value={value}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
            aria-invalid={invalid}
            aria-describedby="intro-audience-help intro-audience-error"
            className="w-24 rounded-md border bg-background px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary disabled:opacity-50"
          />
          <span className="text-sm">%</span>
        </div>
        <p id="intro-audience-help" className="text-xs text-muted-foreground">
          Usually 100. The other new installs do not see the intro. They are a comparison group, so you can measure
          what the video changes.
        </p>
        <p id="intro-audience-error" className="text-xs text-red-700 dark:text-red-400">
          {invalid ? 'Enter a whole number from 0 to 100.' : ''}
        </p>
      </div>
    </details>
  );
}
